import { CHANGE_PARAMETER, QUOTE_SUCCESS, SELECT_PRICE_SUCCESS } from 'pu-redux/actions/QuoteActions';

const crossParameters = (state, action) => {
  switch (action.type) {
    case CHANGE_PARAMETER:
    case QUOTE_SUCCESS:
    case SELECT_PRICE_SUCCESS:
      if (state.getIn(['flexParameters', 'rigid_flex_selector']) === 'Flex') {
        return state.set('parameters', state.get('flexParameters'));
      }
      return state.set('parameters', state.get('rigidFlexParameters'));
    default:
      return state;
  }
};

export default crossParameters;
